import { RouteConfig } from 'vue-router';
const List = () => import('./views/list.vue');
const Read = () => import('./views/read.vue');
const Compose = () => import('./views/compose.vue');
const Mulu = () => import('./views/mulu.vue');
const routers: RouteConfig[] = [
    {
        path: 'list',
        component: List,
    },
    {
        path: 'read',
        component: Read,
    },
    {
        path: 'compose',
        component: Compose,
    },
    {
        path: 'mulu',
        component: Mulu,
    },
    {
        path: '*',
        redirect: 'list'
    },
];
export default routers;

